module.exports = __webpack_public_path__ + "img/Pot2.dc5663cc.svg";